<script>
	import Button from '../components/Button.svelte';
	import FileInput from '../components/FileInput.svelte';
	import Select from '../components/Select.svelte';
	import TextInput from '../components/TextInput.svelte';
    import CollapsibleSection from './CollapsibleSection.svelte';

	export let enctype;
	export let fields;
	export let advancedFields;
	export let onSubmit;
	export let submissionPromise;

	// Formats [{name1, value1}, {name2, value2}] to {name1: value1, name2: value2}
	const buildFormData = (fields) => fields.reduce((formData, field) => {
		let value;
		if (field.value === '' && field.defaultValue !== undefined) {
			value = field.defaultValue;
		} else if (field.component !== "FileInput") {
			value = field.value;
		} else {
			value = field.files[0];
		}

		formData.append(field.name, value);

		return formData;
	}, new FormData());

	const statuses = {
		ERROR: 'Error!',
		READY: 'Submit',
		SUBMITTED: 'Submitted!',
		SUBMITTING: 'Processing...',
	};

	let status = statuses.READY;

	// Reset the form status when the inputs change
	let handleChange = () => {
		status = statuses.READY;
	};

	// Submit the form
	let handleSubmit = () => {
		status = statuses.SUBMITTING;
		onSubmit(buildFormData(fields.concat(advancedFields))); // merge fields and advanced fields before submitting
	};

	// React to submission resolution
	$: {
		// Ignore starting state
		if (submissionPromise === undefined) {
			break $;
		}

		Promise.resolve(submissionPromise).then(() => { // On success
			status = statuses.SUBMITTED;
		}, () => { // On error
			status = statuses.ERROR;
		});
	}
</script>

<form {enctype} on:change={handleChange} on:input={handleChange} on:submit|preventDefault={handleSubmit}>
	{#each fields as field}
		{#if (field.component === 'FileInput')}
			<FileInput
				bind:files="{field.files}"
				id="{field.id}"
				label="{field.label}"
				name="{field.name}"
				required="{field.required}"
			/>
		{:else if (field.component === 'Select')}
			<Select 
				bind:value="{field.value}"
				defaultOption="{field.defaultOption}"
				defaultValue="{field.defaultValue}"
				id="{field.id}"
				label="{field.label}"
				name="{field.name}"
				options="{field.options}"
				required="{field.required}"
			/>
		{:else if (field.component === 'TextInput')}
			<TextInput 
				bind:value="{field.value}"
				defaultValue="{field.defaultValue}"
				id="{field.id}"
				label="{field.label}"
				name="{field.name}"
				placeholder="{field.placeholder}"
				required="{field.required}"
				type="{field.type}"
			/>
		{:else if (field.component === 'Html')}
			{@html field.value}
		{/if}
	{/each}
	<CollapsibleSection headerText={''} >
		<div class="content">
			{#each advancedFields as advancedField}
				{#if (advancedField.component === 'FileInput')}
				<FileInput
					bind:files="{advancedField.files}"
					id="{advancedField.id}"
					label="{advancedField.label}"
					name="{advancedField.name}"
					required="{advancedField.required}"
				/>
				{:else if (advancedField.component === 'Select')}
					<Select 
						bind:value="{advancedField.value}"
						defaultOption="{advancedField.defaultOption}"
						defaultValue="{advancedField.defaultValue}"
						id="{advancedField.id}"
						label="{advancedField.label}"
						name="{advancedField.name}"
						options="{advancedField.options}"
						required="{advancedField.required}"
					/>
				{:else if (advancedField.component === 'TextInput')}
					<TextInput 
						bind:value="{advancedField.value}"
						defaultValue="{advancedField.defaultValue}"
						id="{advancedField.id}"
						label="{advancedField.label}"
						name="{advancedField.name}"
						placeholder="{advancedField.placeholder}"
						required="{advancedField.required}"
						type="{advancedField.type}"
					/>
				{:else if (advancedField.component === 'Html')}
					{@html advancedField.value}
				{/if}
			{/each}
		</div>
	</CollapsibleSection>
	<Button>
		{status}
	</Button>
</form>
